/** @format */

import {
	homefieldIconChevronRight,
	HomefieldIconLibraryModule,
	homefieldIconSignAdd,
	homefieldIconSignCheckCircleFilled,
	HomefieldIconsLibraryService
} from '@dsg-tech/homefield-angular-icons';

import { BaseAddOnProductParserModule } from '@shared/components';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FrequentlyBoughtTogetherComponent } from './frequently-bought-together.component';
import { HmfBadgeComponent, HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { NgModule } from '@angular/core';

@NgModule({
	declarations: [FrequentlyBoughtTogetherComponent],
	imports: [
		BaseAddOnProductParserModule,
		CommonModule,
		FormsModule,
		HmfBadgeComponent,
		HmfButtonComponent,
		HomefieldIconLibraryModule
	],
	exports: [FrequentlyBoughtTogetherComponent]
})
export class FrequentlyBoughtTogetherModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconSignAdd,
			homefieldIconSignCheckCircleFilled,
			homefieldIconChevronRight
		]);
	}
}
